import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ROLES = [
  { id: 'capitan', label: '⚽ Capitán',  color: '#FF6B1A', desc: 'Gestiona tu equipo y desafía rivales' },
  { id: 'arbitro', label: '🟡 Árbitro',  color: '#F59E0B', desc: 'Arbitra partidos y genera ingresos' },
  { id: 'recinto', label: '🏟️ Recinto',  color: '#1A6BFF', desc: 'Administra tus canchas y reservas' },
];

export default function Registro() {
  const navigate     = useNavigate();
  const { registro } = useAuth();

  const [rol,      setRol]      = useState(null);
  const [nombre,   setNombre]   = useState('');
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [celular,  setCelular]  = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  const handleRolClick = (id) => {
    // Recinto tiene su propio flujo de 5 pasos
    if (id === 'recinto') {
      navigate('/registro-recinto');
      return;
    }
    setRol(id);
  };

  const handleRegistro = async () => {
    if (!nombre.trim())           { setError('Ingresa tu nombre'); return; }
    if (!email.trim())            { setError('Ingresa tu email'); return; }
    if (!password)                { setError('Ingresa una contraseña'); return; }
    if (password !== confirm)     { setError('Las contraseñas no coinciden'); return; }
    if (password.length < 6)      { setError('Mínimo 6 caracteres'); return; }

    setLoading(true); setError('');
    const ok = await registro({ nombre, email, password, celular, rol: rol || 'capitan' });
    setLoading(false);
    if (ok) {
      if (rol === 'arbitro' || rol === 'tercer_tiempo') navigate('/app/panel-proveedor');
      else navigate('/app/dashboard');
    } else {
      setError('Error al crear la cuenta. El email puede estar en uso.');
    }
  };

  // Paso 1 — Selección de rol
  if (!rol) {
    return (
      <div style={styles.pagina}>
        <div style={styles.card}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.titulo}>Crear cuenta</div>
          <div style={styles.sub}>¿Cómo quieres participar en TuRival?</div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
            {ROLES.map(r => (
              <button
                key={r.id}
                style={{ ...styles.btnRol, borderColor: r.color }}
                onClick={() => handleRolClick(r.id)}
              >
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: 700, color: 'white', fontSize: 15, fontFamily: "'Barlow Condensed', sans-serif" }}>
                    {r.label}
                  </div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow', sans-serif", marginTop: 2 }}>
                    {r.desc}
                  </div>
                </div>
                <span style={{ color: r.color, fontSize: 18 }}>→</span>
              </button>
            ))}
          </div>

          <div style={styles.login}>
            ¿Ya tienes cuenta?{' '}
            <span style={styles.loginLink} onClick={() => navigate('/login')}>
              Iniciar sesión →
            </span>
          </div>
        </div>
      </div>
    );
  }

  // Paso 2 — Formulario de registro (solo capitán y árbitro)
  const rolInfo = ROLES.find(r => r.id === rol);
  return (
    <div style={styles.pagina}>
      <div style={styles.card}>
        <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
        <div style={styles.titulo}>Crear cuenta</div>

        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <span style={{
            background: `${rolInfo.color}22`, color: rolInfo.color,
            border: `1.5px solid ${rolInfo.color}`,
            borderRadius: 20, padding: '4px 14px', fontSize: 12,
            fontFamily: "'Barlow', sans-serif", fontWeight: 700, cursor: 'pointer',
          }} onClick={() => setRol(null)}>
            {rolInfo.label} ✕
          </span>
        </div>

        <div style={styles.campo}>
          <div style={styles.label}>Nombre completo</div>
          <input style={styles.input} value={nombre}
            onChange={e => { setNombre(e.target.value); setError(''); }}
            placeholder="Pedro González" />
        </div>
        <div style={styles.campo}>
          <div style={styles.label}>Email</div>
          <input style={styles.input} type="email" value={email}
            onChange={e => { setEmail(e.target.value); setError(''); }}
            placeholder="pedro@email.com" />
        </div>
        <div style={styles.campo}>
          <div style={styles.label}>Celular (opcional)</div>
          <input style={styles.input} value={celular}
            onChange={e => setCelular(e.target.value)}
            placeholder="+56 9 1234 5678" />
        </div>
        <div style={styles.campo}>
          <div style={styles.label}>Contraseña</div>
          <input style={styles.input} type="password" value={password}
            onChange={e => { setPassword(e.target.value); setError(''); }}
            placeholder="Mínimo 6 caracteres" />
        </div>
        <div style={styles.campo}>
          <div style={styles.label}>Confirmar contraseña</div>
          <input style={styles.input} type="password" value={confirm}
            onChange={e => { setConfirm(e.target.value); setError(''); }}
            placeholder="Repite tu contraseña"
            onKeyDown={e => e.key === 'Enter' && handleRegistro()} />
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button
          style={{ ...styles.btnRegistro, opacity: loading ? 0.7 : 1, background: rolInfo.color }}
          onClick={handleRegistro} disabled={loading}
        >
          {loading ? 'Creando cuenta...' : `Crear cuenta como ${rolInfo.label} →`}
        </button>

        <div style={styles.login}>
          ¿Ya tienes cuenta?{' '}
          <span style={styles.loginLink} onClick={() => navigate('/login')}>
            Iniciar sesión →
          </span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pagina: {
    minHeight: '100vh', background: '#0D1117',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  },
  card: {
    background: '#161C26', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20, padding: 36, width: '100%', maxWidth: 420,
  },
  logo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: 'white', textAlign: 'center', marginBottom: 6,
  },
  naranja: { color: '#FF6B1A' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: 'white', textAlign: 'center', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    textAlign: 'center', marginBottom: 24, fontFamily: "'Barlow', sans-serif",
  },
  btnRol: {
    width: '100%', padding: '14px 16px',
    background: 'rgba(255,255,255,0.05)',
    border: '1.5px solid', borderRadius: 12, cursor: 'pointer',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    boxSizing: 'border-box',
  },
  campo: { marginBottom: 14 },
  label: {
    fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.4)',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    marginBottom: 6, fontFamily: "'Barlow', sans-serif",
  },
  input: {
    width: '100%', padding: '11px 14px',
    background: 'rgba(255,255,255,0.06)',
    border: '1.5px solid rgba(255,255,255,0.1)',
    borderRadius: 10, fontSize: 14, color: 'white',
    fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box',
  },
  error: {
    color: '#EF4444', fontSize: 12, fontFamily: "'Barlow', sans-serif",
    marginBottom: 12, textAlign: 'center',
    background: 'rgba(239,68,68,0.1)', padding: '8px', borderRadius: 8,
  },
  btnRegistro: {
    width: '100%', padding: '13px', border: 'none',
    borderRadius: 12, cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800, color: 'white', marginBottom: 16,
  },
  login: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    textAlign: 'center', fontFamily: "'Barlow', sans-serif",
  },
  loginLink: { color: '#1A6BFF', cursor: 'pointer', fontWeight: 600 },
};
